
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './Assets/Css/style.css'
import Home from './Pages/Home';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
